import { Layout } from "./components/Layout";
import { getStaticPageCopy } from "./data/i18n";
import { localeFromBrowserLanguages } from "./data/locales";
import { getToolById } from "./data/tools";
import { resolveRoute } from "./lib/routing";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { StaticPage } from "./pages/StaticPage";
import { ToolPage } from "./pages/ToolPage";

export default function App() {
  const pathname = window.location.pathname;
  const browserLocale = localeFromBrowserLanguages(navigator.languages?.length ? navigator.languages : [navigator.language]);
  const route = resolveRoute(pathname, browserLocale);
  const tool = route.kind === "tool" ? getToolById(route.toolId, route.locale) : undefined;
  const staticPage = route.kind === "static" ? getStaticPageCopy(route.page, route.locale) : undefined;

  return (
    <Layout locale={route.locale} pathname={pathname}>
      {route.kind === "home" && <HomePage locale={route.locale} />}
      {tool && <ToolPage tool={tool} locale={route.locale} />}
      {staticPage && <StaticPage title={staticPage.title} body={[...staticPage.body]} locale={route.locale} pathname={pathname} />}
      {route.kind === "not-found" && <NotFoundPage locale={route.locale} pathname={pathname} />}
    </Layout>
  );
}
